var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-btn",class:{
    'head-btn-disabled': _vm.disabled
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.loading)?_c('i',{staticClass:"el-icon el-icon-loading",staticStyle:{"padding-left":"4px"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }